import { render, staticRenderFns } from "./RegistrationsListContacts.vue?vue&type=template&id=386e3938&scoped=true"
import script from "./RegistrationsListContacts.vue?vue&type=script&lang=js"
export * from "./RegistrationsListContacts.vue?vue&type=script&lang=js"
import style0 from "./RegistrationsListContacts.vue?vue&type=style&index=0&id=386e3938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e3938",
  null
  
)

export default component.exports